import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Trophy } from 'lucide-react';
import { api } from '@/lib/api';
import { ChallengeCard } from '@/components/cards';
import { LoadingState, EmptyState } from '@/components/states';

export default function Challenges() {
  const navigate = useNavigate();
  const [challenges, setChallenges] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get('/challenges').then(({ data }) => setChallenges(data)).catch(() => {}).finally(() => setLoading(false));
  }, []);

  return (
    <div className="space-y-8">
      <div className="card-surface relative overflow-hidden p-8">
        <img src="https://images.pexels.com/photos/9534908/pexels-photo-9534908.jpeg?auto=compress&cs=tinysrgb&w=1200" alt="" className="absolute inset-0 h-full w-full object-cover opacity-25" />
        <div className="absolute inset-0 bg-gradient-to-r from-black via-black/70 to-transparent" />
        <div className="relative">
          <span className="inline-flex items-center gap-2 rounded-full bg-brand/20 px-3 py-1 font-mono text-xs uppercase tracking-widest text-brand">
            <Trophy className="h-3.5 w-3.5" /> Compétition
          </span>
          <h1 className="mt-4 font-display text-3xl font-extrabold tracking-tight text-white sm:text-5xl">
            Challenge <span className="text-gradient-orange">Meilleure Musique</span>
          </h1>
          <p className="mt-2 max-w-xl text-muted-foreground">
            Publie tes créations, fais-toi voter par la communauté et grimpe dans le classement.
          </p>
        </div>
      </div>

      {loading ? <LoadingState /> : challenges.length === 0 ? (
        <EmptyState icon={Trophy} title="Aucun challenge actif" description="Reviens bientôt pour de nouveaux défis musicaux." />
      ) : (
        <div className="grid gap-4 sm:grid-cols-2 lg:grid-cols-3">
          {challenges.map((c) => (
            <ChallengeCard key={c.id} challenge={c} onClick={() => navigate(`/challenges/${c.slug}`)} />
          ))}
        </div>
      )}
    </div>
  );
}
